export default __webpack_public_path__ + "static/media/ad930d2a15fdf52caefe86ea515156f1.svg";